export class RouteAddress {
  public country: string;
  public countryCode: string;
  public countryCodeISO3: string;
  public countrySecondarySubdivision: string;
  public countrySubdivision: string;
  public countrySubdivisionName: string;
  public countryTertiarySubdivision: string;
  public freeformAddress: string;
  public municipality: string;
}
